/**
 * BlockedSlot API Contract Schemas
 *
 * Defines Zod schemas for blocked slot management API requests and responses.
 * Used for validation in both backend (NestJS) and frontend (React forms).
 *
 * Feature 3: Quick Slot Block — allows vendors to block calendar slots from online booking.
 */

import { z } from 'zod';

// ============================================
// CREATE BLOCKED SLOT
// ============================================

export const CreateBlockedSlotRequestSchema = z.object({
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD format'),
  startTime: z.string().regex(/^\d{2}:\d{2}$/, 'Time must be HH:mm format'),
  endTime: z.string().regex(/^\d{2}:\d{2}$/, 'Time must be HH:mm format'),
  venueInventoryId: z.string().uuid().optional(), // omit for venue-wide block
  reason: z.string().trim().max(500).optional(),
});
export type CreateBlockedSlotRequest = z.infer<typeof CreateBlockedSlotRequestSchema>;

// ============================================
// QUERY BLOCKED SLOTS
// ============================================

export const BlockedSlotsQuerySchema = z.object({
  startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Start date must be YYYY-MM-DD format'),
  endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'End date must be YYYY-MM-DD format'),
  venueInventoryId: z.string().uuid().optional(),
});
export type BlockedSlotsQuery = z.infer<typeof BlockedSlotsQuerySchema>;
